import { render, staticRenderFns } from "./LanguageAutocomplete.vue?vue&type=template&id=6d0098d2"
import script from "./LanguageAutocomplete.vue?vue&type=script&lang=js"
export * from "./LanguageAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./LanguageAutocomplete.vue?vue&type=style&index=0&id=6d0098d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports